import type { CSSProperties } from 'react';

export const createStyles = (theme?: any, isDark?: boolean) => {
  const darkMenuSurface = isDark
    ? { backgroundColor: '#363636', color: '#ffffff' }
    : {};
  const darkMenuBackground = isDark
    ? { backgroundColor: '#363636 !important' }
    : {};

  const menuPaper: CSSProperties = {
    ...darkMenuSurface,
    height: 'auto',
    maxHeight: 450,
    overflowY: 'auto',
  };

  return {
    selectField: {
      mt: 0,
      cursor: 'pointer',
      '& .MuiOutlinedInput-root': {
        bgcolor: 'background.paper',
        cursor: 'pointer',
      },
      '& .MuiOutlinedInput-input': {
        cursor: 'pointer',
        caretColor: 'transparent',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },
      '& .MuiFormHelperText-root': {
        display: 'none',
        margin: '0px 14px 0px',
      },
    },
    menuPaper,
    menu: {
      '& .MuiPaper-root': {
        ...darkMenuSurface,
        ...darkMenuBackground,
        width: {
          xs: 'calc(343px - 2rem)',
          sm: 'calc(90% - 2rem)',
          md: 'calc(560px - 2rem)',
        },
        maxWidth: {
          xs: 'calc(343px - 2rem)',
          sm: 'calc(90% - 2rem)',
          md: 'calc(560px - 2rem)',
        },
        height: 'auto',
        maxHeight: 450,
        overflowY: 'auto' as const,
      },
      '& .MuiMenu-paper': darkMenuBackground,
      '& .MuiPopover-paper': darkMenuBackground,
      '& .MuiMenu-list': darkMenuBackground,
      '& .MuiList-root': darkMenuBackground,
      '& .MuiListItemText-primary': {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
    },
    optionLabelSx: {
      display: 'block',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: '100%',
      minWidth: 0,
    },
  };
};
